export default __webpack_public_path__ + "static/media/caleb-icon-learning.0fb23d5a.svg";